var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutOg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_1828479",
    clipPath: "url(#clip0_835_66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 10.8335C12.0391 10.8335 11.6666 11.2069 11.6666 11.6667V15.0001C11.6666 15.4593 11.2932 15.8334 10.8332 15.8334H8.33319V3.33355C8.33319 2.62189 7.87986 1.98606 7.19826 1.7494L6.95153 1.66685H10.8332C11.2932 1.66685 11.6666 2.04099 11.6666 2.50028V5.00025C11.6666 5.46015 12.0391 5.83353 12.4999 5.83353C12.9607 5.83353 13.3331 5.46015 13.3331 5.00025V2.50028C13.3331 1.12197 12.2115 0.000305176 10.8332 0.000305176H1.87498C1.84324 0.000305176 1.81669 0.0144957 1.78587 0.0186155C1.74574 0.0152586 1.70744 0.000305176 1.6667 0.000305176C0.74752 0.000305176 0 0.747673 0 1.66685V16.6667C0 17.3784 0.453334 18.0142 1.13494 18.2508L6.14999 19.9226C6.31997 19.9751 6.48904 20.0001 6.66665 20.0001C7.58583 20.0001 8.33319 19.2526 8.33319 18.3334V17.5001H10.8332C12.2115 17.5001 13.3331 16.3785 13.3331 15.0001V11.6667C13.3331 11.2069 12.9607 10.8335 12.4999 10.8335Z",
    fill: "#F45050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 10.8335C12.0391 10.8335 11.6666 11.2069 11.6666 11.6667V15.0001C11.6666 15.4593 11.2932 15.8334 10.8332 15.8334H8.33319V3.33355C8.33319 2.62189 7.87986 1.98606 7.19826 1.7494L6.95153 1.66685H10.8332C11.2932 1.66685 11.6666 2.04099 11.6666 2.50028V5.00025C11.6666 5.46015 12.0391 5.83353 12.4999 5.83353C12.9607 5.83353 13.3331 5.46015 13.3331 5.00025V2.50028C13.3331 1.12197 12.2115 0.000305176 10.8332 0.000305176H1.87498C1.84324 0.000305176 1.81669 0.0144957 1.78587 0.0186155C1.74574 0.0152586 1.70744 0.000305176 1.6667 0.000305176C0.74752 0.000305176 0 0.747673 0 1.66685V16.6667C0 17.3784 0.453334 18.0142 1.13494 18.2508L6.14999 19.9226C6.31997 19.9751 6.48904 20.0001 6.66665 20.0001C7.58583 20.0001 8.33319 19.2526 8.33319 18.3334V17.5001H10.8332C12.2115 17.5001 13.3331 16.3785 13.3331 15.0001V11.6667C13.3331 11.2069 12.9607 10.8335 12.4999 10.8335Z",
    fill: "url(#paint0_linear_835_66)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7555 7.74432L16.4221 4.41108C16.1839 4.17274 15.8255 4.10102 15.5139 4.23011C15.2031 4.35935 14.9997 4.66346 14.9997 5.00021V7.50019H11.6664C11.2064 7.50019 10.833 7.87341 10.833 8.33346C10.833 8.79351 11.2064 9.16673 11.6664 9.16673H14.9997V11.6667C14.9997 12.0035 15.2031 12.3076 15.5139 12.4368C15.8255 12.5659 16.1839 12.4942 16.4221 12.256L19.7555 8.9226C20.0813 8.59682 20.0813 8.0701 19.7555 7.74432Z",
    fill: "#F45050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7555 7.74432L16.4221 4.41108C16.1839 4.17274 15.8255 4.10102 15.5139 4.23011C15.2031 4.35935 14.9997 4.66346 14.9997 5.00021V7.50019H11.6664C11.2064 7.50019 10.833 7.87341 10.833 8.33346C10.833 8.79351 11.2064 9.16673 11.6664 9.16673H14.9997V11.6667C14.9997 12.0035 15.2031 12.3076 15.5139 12.4368C15.8255 12.5659 16.1839 12.4942 16.4221 12.256L19.7555 8.9226C20.0813 8.59682 20.0813 8.0701 19.7555 7.74432Z",
    fill: "url(#paint1_linear_835_66)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_835_66",
    x1: 12.9216,
    y1: 34.423,
    x2: -3.21839,
    y2: 33.2399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_835_66",
    x1: 19.7169,
    y1: 18.51,
    x2: 8.72151,
    y2: 17.1802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_835_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutOg);
export default __webpack_public_path__ + "static/media/logout_og.a1718d65db1b9ffc5b839e5eaac6d53c.svg";
export { ForwardRef as ReactComponent };